import React, { useState } from 'react';
import {
  TableCell,
  TableRow,
  Chip,
  Button,
  Avatar,
  Tooltip,
  ClickAwayListener,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import {
  PayingMemberPayType,
  PayingMemberPayTypeText,
  USER_PAYING_MEMBER_COUPON_TYPE,
} from '../../data/common';
import moment from 'moment';
import CancelRoundedIcon from '@material-ui/icons/CancelRounded';
import AutorenewRoundedIcon from '@material-ui/icons/AutorenewRounded';
import SwapHorizRoundedIcon from '@material-ui/icons/SwapHorizRounded';

const LargeTooltip = withStyles({
  tooltip: {
    fontSize: 14,
  },
})(Tooltip);

const UserPayingMemberTableRow = (props) => {
  const {
    userPayingMember,
    onCancelPayingMember,
    onOpenCouponModal,
    onOpenTransferModal,
  } = props;

  const isTransferred =
    userPayingMember.transferToId != null &&
    userPayingMember.transferToId !== '';

  const isTransferredFrom =
    userPayingMember.transferFromId != null &&
    userPayingMember.transferFromId !== '';

  const [transferTipOpen, setTransferTipOpen] = useState(false);

  const handleCancel = () => {
    onCancelPayingMember(userPayingMember.id);
  };

  const handleOpenCouponModal = () => {
    onOpenCouponModal(userPayingMember);
  };

  const handleOpenTransferModal = () => {
    onOpenTransferModal(userPayingMember);
  };

  return (
    <TableRow>
      <TableCell component="th">{userPayingMember.id}</TableCell>
      <TableCell component="th">
        {userPayingMember.userInfo.realName}
        <Typography variant="caption" color="textSecondary" display="block">
          {userPayingMember.userInfo.id}
        </Typography>
      </TableCell>
      <TableCell>
        {userPayingMember.payingMemberInfo && (
          <div>{userPayingMember.payingMemberInfo.name}</div>
        )}
      </TableCell>
      <TableCell>
        {userPayingMember.payingMemberInfo &&
          userPayingMember.payingMemberInfo.storeInfo && (
            <Chip
              avatar={
                <Avatar
                  src={userPayingMember.payingMemberInfo.storeInfo.imgSrc}
                />
              }
              size="small"
              label={userPayingMember.payingMemberInfo.storeInfo.name}
            />
          )}
      </TableCell>
      <TableCell>
        {moment(userPayingMember.payingTime).format('YYYY-MM-DD HH:mm:ss')}
      </TableCell>
      <TableCell>
        {moment(userPayingMember.startAt).format('YYYY-MM-DD')}
      </TableCell>
      <TableCell>
        {moment(userPayingMember.endAt).format('YYYY-MM-DD')}
      </TableCell>
      <TableCell>
        <Chip
          size="small"
          color={
            userPayingMember.payType === PayingMemberPayType.OFFLINE_PAY
              ? 'secondary'
              : 'primary'
          }
          label={PayingMemberPayTypeText[userPayingMember.payType]}
        />
      </TableCell>
      <TableCell>
        {userPayingMember.orderInfo ? userPayingMember.orderInfo.id : ''}
      </TableCell>
      <TableCell title={userPayingMember.createUserInfo.id}>
        {userPayingMember.createUserInfo.realName}
      </TableCell>
      <TableCell>
        {userPayingMember.consignmentUserInfo && (
          <>{userPayingMember.consignmentUserInfo.realName}</>
        )}
      </TableCell>
      <TableCell>
        {isTransferredFrom && userPayingMember.transferFromUserInfo && (
          <ClickAwayListener onClickAway={() => setTransferTipOpen(false)}>
            <LargeTooltip
              title={
                <>
                  <div>會員ID：{userPayingMember.transferFromUserInfo.id}</div>
                  <div>來源ID：{userPayingMember.transferFromId}</div>
                  <div>
                    轉讓時間：
                    {moment(userPayingMember.transferDate).format(
                      'YYYY-MM-DD HH:mm',
                    )}
                  </div>
                </>
              }
              arrow
              placement="top"
              open={transferTipOpen}
              disableFocusListener
              disableHoverListener
              disableTouchListener>
              <Chip
                size="small"
                icon={<InfoOutlinedIcon style={{ fontSize: 16 }} />}
                label={userPayingMember.transferFromUserInfo.realName}
                clickable
                onClick={() => setTransferTipOpen((prev) => !prev)}
              />
            </LargeTooltip>
          </ClickAwayListener>
        )}
      </TableCell>
      <TableCell>
        {isTransferred ? (
          <Chip
            size="small"
            label={`已轉讓 ${moment(userPayingMember.transferDate).format(
              'YYYY-MM-DD HH:mm:ss',
            )}`}
          />
        ) : (
          userPayingMember.isDelete === true && (
            <Chip
              size="small"
              label={`已取消 ${moment(userPayingMember.deleteDate).format(
                'YYYY-MM-DD HH:mm:ss',
              )}`}
            />
          )
        )}
      </TableCell>
      <TableCell>
        {userPayingMember.payingMemberInfo &&
        userPayingMember.payingMemberInfo.productPackageId ? (
          <>{USER_PAYING_MEMBER_COUPON_TYPE[userPayingMember.couponType]}</>
        ) : (
          '不需領券'
        )}
      </TableCell>
      <TableCell align="right">
        {userPayingMember.isDelete !== true && !isTransferred && (
          <>
            {userPayingMember.payingMemberInfo &&
              userPayingMember.payingMemberInfo.productPackageId &&
              !isTransferredFrom && (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleOpenCouponModal}
                  startIcon={<AutorenewRoundedIcon />}>
                  轉換領券
                </Button>
              )}

            <Button
              variant="contained"
              size="small"
              onClick={handleOpenTransferModal}
              startIcon={<SwapHorizRoundedIcon />}
              disabled={!userPayingMember.canTransfer}
              style={{ marginLeft: '8px' }}>
              轉讓
            </Button>

            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleCancel}
              startIcon={<CancelRoundedIcon />}
              style={{ marginLeft: '8px' }}>
              取消
            </Button>
          </>
        )}
      </TableCell>
    </TableRow>
  );
};

export default UserPayingMemberTableRow;
